import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "skip-forward",
  "use": "skip-forward-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"skip-forward\">\n<path d=\"M5,21c-0.1,0-0.3,0-0.4-0.1C4.2,20.7,4,20.4,4,20V4c0-0.4,0.2-0.7,0.6-0.9C4.9,2.9,5.3,3,5.6,3.2l10,8\n\tc0.2,0.2,0.4,0.5,0.4,0.8s-0.1,0.6-0.4,0.8l-10,8C5.4,20.9,5.2,21,5,21z M6,6.1v11.8l7.4-5.9L6,6.1z\" />\n<path d=\"M19,20c-0.6,0-1-0.4-1-1V5c0-0.6,0.4-1,1-1s1,0.4,1,1v14C20,19.6,19.6,20,19,20z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol